/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var opt = __webpack_require__(1);
	var util = __webpack_require__(2);
	var report = __webpack_require__(8);
	
	var startTime = new Date();
	
	// 保存原先xla对象，用于noConflict的覆盖
	var xlaBefore = window.xla
	
	var _xla = {
	    push: function (param) {
	        if (param.type === 'pv' || param.type === 'pageview') {
	            /**
	             * @function pageview
	             *
	             * @description 用于发送某个指定URL的PV统计请求，通常用于AJAX页面的PV统计。
	             * ```
	             * xla.push({
	             *   type: 'pageview',
	             *   extdata: extdata,
	             *   force: force
	             * });
	             * ```
	             *
	             * @param {object} [extdata] - 额外字段
	             * @param {boolean} [force] - 是否强制上报
	             *
	             * @example
	             * xla.push({
	             *   type: 'pageview',
	             *   extdata: { page: 'login' }
	             * });
	             */
	            report({
	                ii: param.type,
	                ed: param.extdata || {},
	                force: param.force
	            });
	        } else if (param.type === 'event') {
	            /**
	             * @function event
	             *
	             * @desc 用于触发某个事件，如某个按钮的点击，或播放器的播放/停止，以及游戏的开始/暂停等。
	             * ```
	             * xla.push({
	             *   type: 'evet',
	             *   category: category,
	             *   action: action,
	             *   extdata: extdata
	             * });
	             * ```
	             *
	             * @param {string} category - 要监控的目标的类型名称
	             * @param {string} action - 用户跟网页进行交互的动作名称
	             * @param {object} [extdata] - 事件的一些额外信息
	             *
	             * @example
	             * xla.push({
	             *   type: 'event',
	             *   category: 'music',
	             *   action: 'play',
	             *   extdata: { title: 'Hey Jude' }
	             * });
	             */
	            report({
	                ii: param.type,
	                cg: param.category,
	                at: param.action,
	                ed: param.extdata || {},
	                force: param.force
	            });
	        } else if (param.type === 'tp') {
	            report({
	                ii:param.type,
	                tp: param.tp,
	                force: param.force
	            });
	        } else if (param.type === 'globalExtData') {
	            /**
	             * @function globalExtData
	             *
	             * @description 指定额外变量
	             * ```
	             * xla.push({
	             *   type: 'globalExtData',
	             *   data: data
	             * })
	             * ```
	             *
	             * @param {object} data - 额外字段
	             *
	             * @example
	             * xla.push({
	             *   type: 'globalExtData',
	             *   data: { login: '1' }
	             * });
	             */
	            opt.extend(param.data || {});
	        } else if (param.type === 'config') {
	            /**
	             * @function config
	             *
	             * @desc SDK的初始化配置
	             * ```javascript
	             * xla.push({
	             *   type: 'config',
	             *   appid: appid,
	             *   secret: secret,
	             *   event: event,
	             *   force: force
	             * });
	             * ```
	             *
	             * @param {string} appid - 应用的appid
	             * @param {string} secret - 应用的secret
	             * @param {array} [event=['click']] - 使用属性声明方式时的监听事件
	             * @param {boolean} [force=true] - 是否实时上报
	             *
	             * @example
	             * xla.push({
	             *   type: 'config',
	             *   appid: '100',
	             *   secret: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
	             *   event: ['click', 'mouseover']
	             *   force: false
	             * });
	             */
	            opt.config(param.appid, param.secret, param.event, param.force);
	        }
	    },
	
	    // 版本号
	    version: opt.v,
	
	    // 回退上一个版本的xla对象，若上一个版本没有xla，则window.xia等于undefined
	    // 返回当前版本的xla对象
	    noConflict: function () {
	        if (window.xla === _xla) {
	            window.xla = xlaBefore;
	        }
	
	        return _xla;
	    }
	};
	
	/**
	 * @desc sdk加载前有上报
	 */
	if (window.xla instanceof Array) {
	    for (var i = 0; i < window.xla.length; i++) {
	        _xla.push(window.xla[i]);
	    }
	}
	
	/**
	 * @desc 对统计属性声明的DOM进行监听
	 */
	util.documentReady(function () {
	    for (var i = 0; i < opt.event.length; i++) {
	        util.delegate(document, opt.event[i], '[xla-on=' + opt.event[i] + ']', function () {
	            _xla.push({
	                type: 'event',
	                category: this.getAttribute('xla-category'),
	                action: this.getAttribute('xla-action'),
	                extdata: eval('(' + this.getAttribute('xla-extdata') + ')')
	            });
	        });
	    }
	});
	
	/**
	 * @desc 页面卸载时上报页面访问时长
	 * @desc 页面卸载时上报队列剩余数据
	 */
	util.on(window, 'unload', function () {
	    _xla.push({
	        type: 'tp',
	        tp: new Date() - startTime,
	        force: true
	    });
	});
	
	/**
	 * @desc 自动pv上报
	 */
	_xla.push({
	    type: 'pv',
	    extdata: eval('(' + document.body.getAttribute('xla-extdata') + ')')
	});
	
	window.xla = _xla;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(2);
	
	var opt = module.exports =  {
	    /**
	     * @type {string}
	     * @desc 接口版本'
	     */
	    v: '2.0.1',
	
	    /**
	     * @type {string}
	     * @desc 上报接口
	     */
	    furl: util.getParameter('debug') ? '//etl-xlmc-ssl.xunlei.com/api/stat/rt/js' : '//etl-xlmc-ssl.xunlei.com/api/stat/rt/js',
	
	    /**
	     * @type {number}
	     * @desc 应用标识
	     */
	    appid: null,
	
	    /**
	     * @type {string}
	     * @desc md5密钥
	     */
	    s: null,
	
	    /**
	     * @type {object}
	     * @desc 上报公共字段
	     * @property {number} ai - appid         - 站点id
	     * @property {string} dm - domain        - 域名
	     * @property {string} ul - url           - 链接
	     * @property {string} tt - title         - 页面标题
	     * @property {string} sn - screen        - 屏幕尺寸
	     * @property {string} cd - colordepth    - 颜色深度
	     * @property {string} rr - referrer      - 页面来源
	     * @property {string} rf - referfrom     - 页面来源
	     * @property {string} ua - httpuseragent - 用户代理
	     * @property {string} lg - language      - 页面语言
	     * @property {string} ci - cookieid      - 访客标识
	     */
	    comm: {
	        ai: null,
	        dm: window.realdomain || document.domain,
	        ul: document.URL,
	        tt: document.title,
	        sn: window.screen.width + 'x' + window.screen.height,
	        cd: window.screen.colorDepth,
	        rr: document.referrer,
	        rf: util.getReferfrom() || '',
	        ua: navigator.userAgent,
	        lg: navigator.language,
	        ci: util.getCookieId(),
	        ed: {}
	    },
	
	    /**
	     * @type {object}
	     * @desc pv上报字段
	     * @property {string} ii - interid - 上报类型 <pv | event | pageview | tp>
	     * @property {number} tm - time    - 上报时间
	     */
	    // pv: {
	    //     ii: null,
	    //     tm: null,
	    //     pu: null
	    // },
	
	    /**
	     * @type {object}
	     * @desc event上报字段
	     * @property {string} ii - interid  - 上报类型 <pv | event | pageview | tp>
	     * @property {number} tm - time     - 上报时间
	     * @property {string} cg - category - 目标分类
	     * @property {string} at - action   - 动作类型
	     * @property {string} ed - extdata  - 自定义上报内容
	     */
	    // event: {
	    //     ii: null,
	    //     tm: null,
	    //     cg: null,
	    //     at: null,
	    //     ed: null
	    // },
	
	    /**
	     * @type {object}
	     * @desc tp上报字段
	     * @property {string} ii - interid  - 上报类型 <pv | event | pageview | tp>
	     * @property {number} tm - time     - 上报时间
	     * @property {number} tp - timepage - 页面访问时长
	     */
	    // tp: {
	    //     ii: null,
	    //     tm: null,
	    //     tp: null
	    // },
	
	    /**
	     * @func extend
	     * @desc 拓展opt的公共字段
	     * @returns {object} 拓展后的opt公共字段
	     */
	    extend: function (param) {
	        opt.comm.ed = util.deepExtend({}, opt.comm.ed, param);
	        return opt.comm;
	    },
	
	    /**
	     * @func config
	     * @desc 配置appid和secret
	     */
	    config: function (appid, secret, event, force) {
	        this.appid = appid;
	        this.comm.ai = appid;
	        this.s = secret;
	        if (typeof force === 'boolean') {
	            this.force = force;
	        }
	
	        if (event) {
	            this.event = util.unique(this.event.concat(event));
	        }
	    },
	
	    /**
	     * @type {array}
	     * @desc 监听事件
	     */
	    event: ['click'],
	
	    /**
	     * @type {boolean}
	     * @desc 调试模式
	     */
	    debug: util.getParameter('debug'),
	
	    /**
	     * @type {boolean}
	     * @desc 强制上报
	     */
	    force: true
	};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var md5 = __webpack_require__(3)
	var opt = __webpack_require__(1);
	var cookie = __webpack_require__(7);
	
	var util = module.exports = {
	    /**
	     * @func getReferfrom
	     * @desc 获取站点来源
	     * @returns {string} 返回referfrom
	     */
	    getReferfrom: function () {
	        var referfrom = util.getParameter('referfrom');
	        if (referfrom) {
	            cookie.set(document.domain, 'XLA_RF' + opt.appid, referfrom, 24);
	        } else {
	            referfrom = cookie.get('XLA_RF' + opt.appid);
	        }
	        return referfrom;
	    },
	
	    /**
	     * @func getCookieId
	     * @desc 获取cookieid
	     * @returns {string} 返回cookieId
	     */
	    getCookieId: function () {
	        var cookieId = cookie.get('XLA_CI');
	        if (!cookieId) {
	            var random = Math.random();
	            var browser = navigator.appName + "_" + navigator.appVersion + "_" + navigator.userAgent + "_" + navigator.appCodeName + "_" + navigator.platform;
	            var nowtime = new Date().valueOf();
	            cookieId = md5(nowtime + browser + random);
	            cookie.set(document.domain, 'XLA_CI', cookieId, 24);
	        }
	        return cookieId;
	    },
	
	    /**
	     * @func
	     * @desc 获取链接参数
	     * @param {string} name - 参数字段
	     * @returns {string} 返回参数值或null
	     */
	    getParameter: function (name) {
	        var pattern = new RegExp("[?&]" + name + "\=([^&#]+)", "g");
	        try {
	            var matcher = pattern.exec(document.location.href);
	        } catch (e) {
	        }
	        ;
	        if (null != matcher) {
	            return decodeURIComponent(matcher[1]);
	        } else {
	            return null;
	        }
	    },
	
	    /**
	     * @func deepExtend
	     * @desc 深度拓展对象
	     * @returns {object} 返回拓展好的对象
	     */
	    deepExtend: function (out) {
	        out = out || {};
	
	        for (var i = 1; i < arguments.length; i++) {
	            var obj = arguments[i];
	
	            if (!obj)
	                continue;
	
	            for (var key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    if (typeof obj[key] === 'object' && obj[key] !== null)
	                        out[key] = this.deepExtend(out[key], obj[key]);
	                    else
	                        out[key] = obj[key];
	                }
	            }
	        }
	
	        return out;
	    },
	
	    /**
	     * @type {object}
	     * @desc 打印错误日志
	     */
	    print: {
	        msg: function (msg) {
	            if (window.console && window.console.info) {
	                console.info(msg);
	            }
	        },
	        err: function (err) {
	            if (window.console && window.console.error) {
	                console.error(err);
	            }
	        }
	    },
	
	    /**
	     * @func on
	     * @desc 事件绑定
	     */
	    on: function (el, eventName, handler) {
	        if (el.addEventListener) {
	            el.addEventListener(eventName, handler);
	        } else {
	            el.attachEvent('on' + eventName, function () {
	                handler.call(el);
	            });
	        }
	    },
	
	    /**
	     * @func delegate
	     * @desc 事件委托
	     * @param {object} el        - 委托元素
	     * @param {string} eventName - 事件类型，多个事件以逗号分隔
	     * @param {string} selector  - 绑定元素选择器，仅支持属性选择器
	     * @param {object} handler   - 回调函数
	     */
	    delegate: function (el, eventName, selector, handler) {
	        var that = this;
	        var eventList = eventName.split(',');
	
	        for (var i = 0; i < eventList.length; i++) {
	            this.on(el, eventList[i], function (e) {
	                e = e || window.event;
	                var target = e.target || e.srcElement;
	                that.bubble(target, selector, handler);
	            });
	        }
	    },
	
	    /**
	     * @func bubble
	     * @desc 事件冒泡
	     * @param {object} el       - 当前元素
	     * @param {string} selector - 选择元素
	     * @param {object} handler  - 回调函数
	     */
	    bubble: function (el, selector, handler) {
	        var attr = selector.substr(1, selector.length - 2).split('=');
	        var name = attr[0];
	        var value = attr[1];
	
	        if (el && el.getAttribute && el.getAttribute(name) === value) {
	            handler.call(el);
	        }
	
	        if (el && el !== document) {
	            this.bubble(el.parentNode, selector, handler);
	        }
	    },
	
	    /**
	     * @func imageBeacon
	     * @desc 使用Image Beacon让浏览器通过GET 请求获取图片。
	     */
	    imageBeacon: function (src, successCallback, errorCallback) {
	        var img = new Image();
	        img.onload = successCallback;
	        img.onerror = errorCallback;
	        img.src = src;
	    },
	
	    /**
	     * @func documentReady
	     * @desc 页面加载完成回调
	     */
	    documentReady: function (fn) {
	        if (document.readyState !== 'loading') {
	            fn();
	        } else if (window.addEventListener) {
	            window.addEventListener('DOMContentLoaded', fn);
	        } else {
	            window.attachEvent('onreadystatechange', function () {
	                if (document.readyState != 'loading') {
	                    fn();
	                }
	            });
	        }
	    },
	
	    /**
	     * @func unique
	     * @desc 数组去重
	     */
	    unique: function (arr) {
	        var res = [];
	        var json = {};
	        for (var i = 0; i < arr.length; i++) {
	            if (!json[arr[i]]) {
	                res.push(arr[i]);
	                json[arr[i]] = 1;
	            }
	        }
	        return res;
	    },
	
	    /**
	     * @func browserJudge
	     * @desc 浏览器判断
	     * @return Number 返回的url长度
	     */
	    getBroswer: function () {
	        var Sys = {};
	        var ua = navigator.userAgent.toLowerCase();
	        var s;
	        (s = ua.match(/edge\/([\d.]+)/)) ? Sys.edge = s[1] :
	            (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
	                (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
	                    (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
	                        (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
	                            (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
	                                (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 
	                                    (s = ua.match(/macintosh|mac os x/)) ? Sys.mac = s[0] : 0;
	
	        if (Sys.edge) return 8182;
	        if (Sys.ie) return 2048;
	        if (Sys.firefox) return 8182;
	        if (Sys.chrome) return 8182;
	        if (Sys.opera) return 8182;
	        if (Sys.safari) return 8182;
	        if (Sys.mac) return 8182;
	
	        return 4096;
	    }
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(4),
	      utf8 = __webpack_require__(5).utf8,
	      isBuffer = __webpack_require__(6),
	      bin = __webpack_require__(5).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = {
	    /**
	     * @func getCookie
	     * @desc 获取cookie字段
	     * @param {string} name - 字段名 
	     * @returns {(string|object)} 返回字段值或整个cookie对象
	     */
	    get: function (name) {
	        var cookie = {};
	        var cookieSplit = document.cookie.split('; ');
	        var keyValue;
	
	        for (var i = 0; i < cookieSplit.length; i++) {
	            keyValue = cookieSplit[i].split('=');
	            cookie[keyValue[0]] = keyValue[1];
	        }
	
	        return name ? cookie[name] : cookie;
	    },
	
	    /**
	     * @func setCookie
	     * @desc 设置cookie字段
	     * @param {string} d - cookie域名 
	     * @param {string} e - cookie参数
	     * @param {string} t - cookie值
	     * @param {number} n - 过期小时数
	     */
	    set: function (domain, key, value, hour) {
	        if (hour) {
	            var i = new Date((new Date()).getTime() + hour * 36e5);
	            document.cookie = key + "=" + escape(value) + ";path=/;domain=" + domain + ";expires=" + i.toGMTString();
	        } else {
	            document.cookie = key + "=" + escape(value) + ";path=/;domain=" + domain;
	        }
	    }
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Report module.
	 * @module report
	 */
	var md5 = __webpack_require__(3)
	var opt = __webpack_require__(1);
	var util = __webpack_require__(2);
	var JSON2 = 'JSON' in window ? JSON : __webpack_require__(9);
	
	var _queue = [];
	
	var _createUrl = function (queue) {
	    var url = opt.furl;
	    var param;
	    var query;
	    var value; // 用于计算签名
	    var sig;
	
	    if (queue.length === 1) {
	        param = util.deepExtend({}, opt.comm, queue[0]);
	    } else {
	        param = util.deepExtend({}, opt.comm, {
	            il: queue
	        });
	    }
	
	    param = JSON2.stringify(param);
	
	    value = 'appId=' + opt.appid + 'log=' + param + 'v=' + opt.v;
	
	    sig = md5(value + opt.s);
	
	    query = 'appId=' + opt.appid + '&log=' + encodeURIComponent(param) + '&v=' + opt.v + '&sig=' + sig;
	
	    return url + '?' + query; 
	};
	
	/**
	 * @func beacon
	 * @desc 统一回调的Image Beacon
	 */
	function beacon (url) {
	    util.imageBeacon(url, function () {
	        opt.debug && util.print.msg('Report success: ' + url + ':)');
	    }, function () {
	        opt.debug && util.print.err('Report error: ' + url + ':(');
	    });
	}
	
	/**
	 * @var _lastURL
	 * @desc URL缓存，存放上一次未上报的URL
	 */
	var _lastUrl = '';
	
	/**
	 * @func report
	 * @desc 上报
	 * @param {object} param - 上报参数对象
	 */
	var report = module.exports = function (param) {
	    var force; // 是否实时上报
	
	    if (param.force === false) {
	        force = param.force;
	    } else {
	        force = opt.force;
	    }
	
	
	    delete param.force;
	
	    _queue.push(util.deepExtend({}, param, {
	        tm: Math.round((new Date()).getTime() / 1000)
	    }));
	
	    if (opt.debug) {
	        util.print.msg('Report has been push into queue: ' + JSON2.stringify(param));
	    }
	
	    var url = _createUrl(_queue);
	
	    if (url.length > util.getBroswer()) {
	        if (_queue.length === 1) {
	            util.print.err('Report error: your single report is too long.');
	            _queue = [];
	        } else {
	            beacon(_lastUrl);
	            _queue.splice(0, _queue.length - 1);
	
	            if (force) {
	                beacon(_createUrl(_queue));
	            }
	        }
	    } else {
	        if (force) {
	            beacon(url);
	            _queue = [];
	        } else {
	            _lastUrl = url;
	        }
	    }
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	// For use in Node.js
	
	var JSON2 = __webpack_require__(10);
	var cycle = __webpack_require__(11);
	
	JSON2.decycle = cycle.decycle;
	JSON2.retrocycle = cycle.retrocycle;
	
	module.exports = JSON2;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	    json2.js
	    2011-10-19
	
	    Public Domain.
	
	    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
	
	    See http://www.JSON.org/js.html
	
	
	    This code should be minified before deployment.
	    See http://javascript.crockford.com/jsmin.html
	
	    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
	    NOT CONTROL.
	
	
	    This file creates a global JSON object containing two methods: stringify
	    and parse.
	
	        JSON.stringify(value, replacer, space)
	            value       any JavaScript value, usually an object or array.
	
	            replacer    an optional parameter that determines how object
	                        values are stringified for objects. It can be a
	                        function or an array of strings.
	
	            space       an optional parameter that specifies the indentation
	                        of nested structures. If it is omitted, the text will
	                        be packed without extra whitespace. If it is a number,
	                        it will specify the number of spaces to indent at each
	                        level. If it is a string (such as '\t' or '&nbsp;'),
	                        it contains the characters used to indent at each level.
	
	            This method produces a JSON text from a JavaScript value.
	
	            When an object value is found, if the object contains a toJSON
	            method, its toJSON method will be called and the result will be
	            stringified. A toJSON method does not serialize: it returns the
	            value represented by the name/value pair that should be serialized,
	            or undefined if nothing should be serialized. The toJSON method
	            will be passed the key associated with the value, and this will be
	            bound to the value
	
	            For example, this would serialize Dates as ISO strings.
	
	                Date.prototype.toJSON = function (key) {
	                    function f(n) {
	                        // Format integers to have at least two digits.
	                        return n < 10 ? '0' + n : n;
	                    }
	
	                    return this.getUTCFullYear()   + '-' +
	                         f(this.getUTCMonth() + 1) + '-' +
	                         f(this.getUTCDate())      + 'T' +
	                         f(this.getUTCHours())     + ':' +
	                         f(this.getUTCMinutes())   + ':' +
	                         f(this.getUTCSeconds())   + 'Z';
	                };
	
	            You can provide an optional replacer method. It will be passed the
	            key and value of each member, with this bound to the containing
	            object. The value that is returned from your method will be
	            serialized. If your method returns undefined, then the member will
	            be excluded from the serialization.
	
	            If the replacer parameter is an array of strings, then it will be
	            used to select the members to be serialized. It filters the results
	            such that only members with keys listed in the replacer array are
	            stringified.
	
	            Values that do not have JSON representations, such as undefined or
	            functions, will not be serialized. Such values in objects will be
	            dropped; in arrays they will be replaced with null. You can use
	            a replacer function to replace those with JSON values.
	            JSON.stringify(undefined) returns undefined.
	
	            The optional space parameter produces a stringification of the
	            value that is filled with line breaks and indentation to make it
	            easier to read.
	
	            If the space parameter is a non-empty string, then that string will
	            be used for indentation. If the space parameter is a number, then
	            the indentation will be that many spaces.
	
	            Example:
	
	            text = JSON.stringify(['e', {pluribus: 'unum'}]);
	            // text is '["e",{"pluribus":"unum"}]'
	
	
	            text = JSON.stringify(['e', {pluribus: 'unum'}], null, '\t');
	            // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
	
	            text = JSON.stringify([new Date()], function (key, value) {
	                return this[key] instanceof Date ?
	                    'Date(' + this[key] + ')' : value;
	            });
	            // text is '["Date(---current time---)"]'
	
	
	        JSON.parse(text, reviver)
	            This method parses a JSON text to produce an object or array.
	            It can throw a SyntaxError exception.
	
	            The optional reviver parameter is a function that can filter and
	            transform the results. It receives each of the keys and values,
	            and its return value is used instead of the original value.
	            If it returns what it received, then the structure is not modified.
	            If it returns undefined then the member is deleted.
	
	            Example:
	
	            // Parse the text. Values that look like ISO date strings will
	            // be converted to Date objects.
	
	            myData = JSON.parse(text, function (key, value) {
	                var a;
	                if (typeof value === 'string') {
	                    a =
	/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
	                    if (a) {
	                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
	                            +a[5], +a[6]));
	                    }
	                }
	                return value;
	            });
	
	            myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
	                var d;
	                if (typeof value === 'string' &&
	                        value.slice(0, 5) === 'Date(' &&
	                        value.slice(-1) === ')') {
	                    d = new Date(value.slice(5, -1));
	                    if (d) {
	                        return d;
	                    }
	                }
	                return value;
	            });
	
	
	    This is a reference implementation. You are free to copy, modify, or
	    redistribute.
	*/
	
	/*jslint evil: true, regexp: true */
	
	/*members "", "\b", "\t", "\n", "\f", "\r", "\"", JSON, "\\", apply,
	    call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
	    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
	    lastIndex, length, parse, prototype, push, replace, slice, stringify,
	    test, toJSON, toString, valueOf
	*/
	
	
	(function (JSON) {
	    'use strict';
	
	    function f(n) {
	        // Format integers to have at least two digits.
	        return n < 10 ? '0' + n : n;
	    }
	
	    /* DDOPSON-2012-04-16 - mutating global prototypes is NOT allowed for a well-behaved module.  
	     * It's also unneeded, since Date already defines toJSON() to the same ISOwhatever format below
	     * Thus, we skip this logic for the CommonJS case where 'exports' is defined
	     */
	    if (false) {
	      if (typeof Date.prototype.toJSON !== 'function') {
	          Date.prototype.toJSON = function (key) {
	
	              return isFinite(this.valueOf())
	                  ? this.getUTCFullYear()     + '-' +
	                      f(this.getUTCMonth() + 1) + '-' +
	                      f(this.getUTCDate())      + 'T' +
	                      f(this.getUTCHours())     + ':' +
	                      f(this.getUTCMinutes())   + ':' +
	                      f(this.getUTCSeconds())   + 'Z'
	                  : null;
	          };
	      }
	      
	      if (typeof String.prototype.toJSON !== 'function') {
	        String.prototype.toJSON = function (key) { return this.valueOf(); };
	      }
	
	      if (typeof Number.prototype.toJSON !== 'function') {
	        Number.prototype.toJSON = function (key) { return this.valueOf(); };
	      }
	      
	      if (typeof Boolean.prototype.toJSON !== 'function') {
	        Boolean.prototype.toJSON = function (key) { return this.valueOf(); };
	      }
	    }
	    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	        gap,
	        indent,
	        meta = {    // table of character substitutions
	            '\b': '\\b',
	            '\t': '\\t',
	            '\n': '\\n',
	            '\f': '\\f',
	            '\r': '\\r',
	            '"' : '\\"',
	            '\\': '\\\\'
	        },
	        rep;
	
	
	    function quote(string) {
	
	// If the string contains no control characters, no quote characters, and no
	// backslash characters, then we can safely slap some quotes around it.
	// Otherwise we must also replace the offending characters with safe escape
	// sequences.
	
	        escapable.lastIndex = 0;
	        return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
	            var c = meta[a];
	            return typeof c === 'string'
	                ? c
	                : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
	        }) + '"' : '"' + string + '"';
	    }
	
	
	    function str(key, holder) {
	
	// Produce a string from holder[key].
	
	        var i,          // The loop counter.
	            k,          // The member key.
	            v,          // The member value.
	            length,
	            mind = gap,
	            partial,
	            value = holder[key];
	
	// If the value has a toJSON method, call it to obtain a replacement value.
	
	        if (value && typeof value === 'object' &&
	                typeof value.toJSON === 'function') {
	            value = value.toJSON(key);
	        }
	
	// If we were called with a replacer function, then call the replacer to
	// obtain a replacement value.
	
	        if (typeof rep === 'function') {
	            value = rep.call(holder, key, value);
	        }
	
	// What happens next depends on the value's type.
	
	        switch (typeof value) {
	        case 'string':
	            return quote(value);
	
	        case 'number':
	
	// JSON numbers must be finite. Encode non-finite numbers as null.
	
	            return isFinite(value) ? String(value) : 'null';
	
	        case 'boolean':
	        case 'null':
	
	// If the value is a boolean or null, convert it to a string. Note:
	// typeof null does not produce 'null'. The case is included here in
	// the remote chance that this gets fixed someday.
	
	            return String(value);
	
	// If the type is 'object', we might be dealing with an object or an array or
	// null.
	
	        case 'object':
	
	// Due to a specification blunder in ECMAScript, typeof null is 'object',
	// so watch out for that case.
	
	            if (!value) {
	                return 'null';
	            }
	
	// Make an array to hold the partial results of stringifying this object value.
	
	            gap += indent;
	            partial = [];
	
	// Is the value an array?
	
	            if (Object.prototype.toString.apply(value) === '[object Array]') {
	
	// The value is an array. Stringify every element. Use null as a placeholder
	// for non-JSON values.
	
	                length = value.length;
	                for (i = 0; i < length; i += 1) {
	                    partial[i] = str(i, value) || 'null';
	                }
	
	// Join all of the elements together, separated with commas, and wrap them in
	// brackets.
	
	                v = partial.length === 0
	                    ? '[]'
	                    : gap
	                    ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']'
	                    : '[' + partial.join(',') + ']';
	                gap = mind;
	                return v;
	            }
	
	// If the replacer is an array, use it to select the members to be stringified.
	
	            if (rep && typeof rep === 'object') {
	                length = rep.length;
	                for (i = 0; i < length; i += 1) {
	                    if (typeof rep[i] === 'string') {
	                        k = rep[i];
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
	                        }
	                    }
	                }
	            } else {
	
	// Otherwise, iterate through all of the keys in the object.
	
	                for (k in value) {
	                    if (Object.prototype.hasOwnProperty.call(value, k)) {
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
	                        }
	                    }
	                }
	            }
	
	// Join all of the member texts together, separated with commas,
	// and wrap them in braces.
	
	            v = partial.length === 0
	                ? '{}'
	                : gap
	                ? '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}'
	                : '{' + partial.join(',') + '}';
	            gap = mind;
	            return v;
	        }
	    }
	
	// If the JSON object does not yet have a stringify method, give it one.
	
	    if (typeof JSON.stringify !== 'function') {
	        JSON.stringify = function (value, replacer, space) {
	
	// The stringify method takes a value and an optional replacer, and an optional
	// space parameter, and returns a JSON text. The replacer can be a function
	// that can replace values, or an array of strings that will select the keys.
	// A default replacer method can be provided. Use of the space parameter can
	// produce text that is more easily readable.
	
	            var i;
	            gap = '';
	            indent = '';
	
	// If the space parameter is a number, make an indent string containing that
	// many spaces.
	
	            if (typeof space === 'number') {
	                for (i = 0; i < space; i += 1) {
	                    indent += ' ';
	                }
	
	// If the space parameter is a string, it will be used as the indent string.
	
	            } else if (typeof space === 'string') {
	                indent = space;
	            }
	
	// If there is a replacer, it must be a function or an array.
	// Otherwise, throw an error.
	
	            rep = replacer;
	            if (replacer && typeof replacer !== 'function' &&
	                    (typeof replacer !== 'object' ||
	                    typeof replacer.length !== 'number')) {
	                throw new Error('JSON.stringify');
	            }
	
	// Make a fake root object containing our value under the key of ''.
	// Return the result of stringifying the value.
	
	            return str('', {'': value});
	        };
	    }
	
	
	// If the JSON object does not yet have a parse method, give it one.
	
	    if (typeof JSON.parse !== 'function') {
	        JSON.parse = function (text, reviver) {
	
	// The parse method takes a text and an optional reviver function, and returns
	// a JavaScript value if the text is a valid JSON text.
	
	            var j;
	
	            function walk(holder, key) {
	
	// The walk method is used to recursively walk the resulting structure so
	// that modifications can be made.
	
	                var k, v, value = holder[key];
	                if (value && typeof value === 'object') {
	                    for (k in value) {
	                        if (Object.prototype.hasOwnProperty.call(value, k)) {
	                            v = walk(value, k);
	                            if (v !== undefined) {
	                                value[k] = v;
	                            } else {
	                                delete value[k];
	                            }
	                        }
	                    }
	                }
	                return reviver.call(holder, key, value);
	            }
	
	
	// Parsing happens in four stages. In the first stage, we replace certain
	// Unicode characters with escape sequences. JavaScript handles many characters
	// incorrectly, either silently deleting them, or treating them as line endings.
	
	            text = String(text);
	            cx.lastIndex = 0;
	            if (cx.test(text)) {
	                text = text.replace(cx, function (a) {
	                    return '\\u' +
	                        ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
	                });
	            }
	
	// In the second stage, we run the text against regular expressions that look
	// for non-JSON patterns. We are especially concerned with '()' and 'new'
	// because they can cause invocation, and '=' because it can cause mutation.
	// But just to be safe, we want to reject all unexpected forms.
	
	// We split the second stage into 4 regexp operations in order to work around
	// crippling inefficiencies in IE's and Safari's regexp engines. First we
	// replace the JSON backslash pairs with '@' (a non-JSON character). Second, we
	// replace all simple value tokens with ']' characters. Third, we delete all
	// open brackets that follow a colon or comma or that begin the text. Finally,
	// we look to see that the remaining characters are only whitespace or ']' or
	// ',' or ':' or '{' or '}'. If that is so, then the text is safe for eval.
	
	            if (/^[\],:{}\s]*$/
	                    .test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@')
	                        .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
	                        .replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
	
	// In the third stage we use the eval function to compile the text into a
	// JavaScript structure. The '{' operator is subject to a syntactic ambiguity
	// in JavaScript: it can begin a block or an object literal. We wrap the text
	// in parens to eliminate the ambiguity.
	
	                j = eval('(' + text + ')');
	
	// In the optional fourth stage, we recursively walk the new structure, passing
	// each name/value pair to a reviver function for possible transformation.
	
	                return typeof reviver === 'function'
	                    ? walk({'': j}, '')
	                    : j;
	            }
	
	// If the text is not JSON parseable, then a SyntaxError is thrown.
	
	            throw new SyntaxError('JSON.parse');
	        };
	    }
	})(
	    
	    // Create a JSON object only if one does not already exist. We create the
	    // methods in a closure to avoid creating global variables.
	    
	  ( true) ? 
	    exports : 
	    (window.JSON ? 
	      (window.JSON) :
	      (window.JSON = {})
	    )
	);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	// cycle.js
	// 2011-08-24
	
	/*jslint evil: true, regexp: true */
	
	/*members $ref, apply, call, decycle, hasOwnProperty, length, prototype, push,
	    retrocycle, stringify, test, toString
	*/
	
	(function (exports) {
	
	if (typeof exports.decycle !== 'function') {
	    exports.decycle = function decycle(object) {
	        'use strict';
	
	// Make a deep copy of an object or array, assuring that there is at most
	// one instance of each object or array in the resulting structure. The
	// duplicate references (which might be forming cycles) are replaced with
	// an object of the form
	//      {$ref: PATH}
	// where the PATH is a JSONPath string that locates the first occurance.
	// So,
	//      var a = [];
	//      a[0] = a;
	//      return JSON.stringify(JSON.decycle(a));
	// produces the string '[{"$ref":"$"}]'.
	
	// JSONPath is used to locate the unique object. $ indicates the top level of
	// the object or array. [NUMBER] or [STRING] indicates a child member or
	// property.
	
	        var objects = [],   // Keep a reference to each unique object or array
	            paths = [];     // Keep the path to each unique object or array
	
	        return (function derez(value, path) {
	
	// The derez recurses through the object, producing the deep copy.
	
	            var i,          // The loop counter
	                name,       // Property name
	                nu;         // The new object or array
	
	            switch (typeof value) {
	            case 'object':
	
	// typeof null === 'object', so get out if this value is not really an object.
	
	                if (!value) {
	                    return null;
	                }
	
	// If the value is an object or array, look to see if we have already
	// encountered it. If so, return a $ref/path object. This is a hard way,
	// linear search that will get slower as the number of unique objects grows.
	
	                for (i = 0; i < objects.length; i += 1) {
	                    if (objects[i] === value) {
	                        return {$ref: paths[i]};
	                    }
	                }
	
	// Otherwise, accumulate the unique value and its path.
	
	                objects.push(value);
	                paths.push(path);
	
	// If it is an array, replicate the array.
	
	                if (Object.prototype.toString.apply(value) === '[object Array]') {
	                    nu = [];
	                    for (i = 0; i < value.length; i += 1) {
	                        nu[i] = derez(value[i], path + '[' + i + ']');
	                    }
	                } else {
	
	// If it is an object, replicate the object.
	
	                    nu = {};
	                    for (name in value) {
	                        if (Object.prototype.hasOwnProperty.call(value, name)) {
	                            nu[name] = derez(value[name],
	                                path + '[' + JSON.stringify(name) + ']');
	                        }
	                    }
	                }
	                return nu;
	            case 'number':
	            case 'string':
	            case 'boolean':
	                return value;
	            }
	        }(object, '$'));
	    };
	}
	
	
	if (typeof exports.retrocycle !== 'function') {
	    exports.retrocycle = function retrocycle($) {
	        'use strict';
	
	// Restore an object that was reduced by decycle. Members whose values are
	// objects of the form
	//      {$ref: PATH}
	// are replaced with references to the value found by the PATH. This will
	// restore cycles. The object will be mutated.
	
	// The eval function is used to locate the values described by a PATH. The
	// root object is kept in a $ variable. A regular expression is used to
	// assure that the PATH is extremely well formed. The regexp contains nested
	// * quantifiers. That has been known to have extremely bad performance
	// problems on some browsers for very long strings. A PATH is expected to be
	// reasonably short. A PATH is allowed to belong to a very restricted subset of
	// Goessner's JSONPath.
	
	// So,
	//      var s = '[{"$ref":"$"}]';
	//      return JSON.retrocycle(JSON.parse(s));
	// produces an array containing a single element which is the array itself.
	
	        var px =
	            /^\$(?:\[(?:\d+|\"(?:[^\\\"\u0000-\u001f]|\\([\\\"\/bfnrt]|u[0-9a-zA-Z]{4}))*\")\])*$/;
	
	        (function rez(value) {
	
	// The rez function walks recursively through the object looking for $ref
	// properties. When it finds one that has a value that is a path, then it
	// replaces the $ref object with a reference to the value that is found by
	// the path.
	
	            var i, item, name, path;
	
	            if (value && typeof value === 'object') {
	                if (Object.prototype.toString.apply(value) === '[object Array]') {
	                    for (i = 0; i < value.length; i += 1) {
	                        item = value[i];
	                        if (item && typeof item === 'object') {
	                            path = item.$ref;
	                            if (typeof path === 'string' && px.test(path)) {
	                                value[i] = eval(path);
	                            } else {
	                                rez(item);
	                            }
	                        }
	                    }
	                } else {
	                    for (name in value) {
	                        if (typeof value[name] === 'object') {
	                            item = value[name];
	                            if (item) {
	                                path = item.$ref;
	                                if (typeof path === 'string' && px.test(path)) {
	                                    value[name] = eval(path);
	                                } else {
	                                    rez(item);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }($));
	        return $;
	    };
	}
	}) (
	  ( true) ? 
	    exports : 
	    (window.JSON ? 
	      (window.JSON) :
	      (window.JSON = {})
	    )
	);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// xla.min.js